import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import moment from "moment";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import { selectAuth } from "../../../auth/auth.selector";
import { fetchApiData } from "../../../../redux/reducers/commonApiSlice";
import { trainerInfo } from "../../../../data/ApiEndpoints";
import { BodyBuilder } from "../../../../exports/Images";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import FiltersTrainerDetails from "./FiltersTrainerDetails";
import OccupencyDetails from "../../../components-react/OccupencyDetails";
import PtDetails from "./PtDetails";
import TrainerDetailsPage from "../TrainerDetailsPage";
import { convertStraight } from "../../../common-data/Converts";
import { isManagerRole as checkIsManagerRole } from "../../../common-data/Conversions";

const TrainerInfo = ({ prevFilters }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const { user } = userInfo || {};
  const isAdmin = user?.account_type === "admin";
  const isGym = user?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(user);
  const { data, loading } = useSelector((state) => state.common);

  const [isPage, setIsPage] = useState(0);
  const iniTbDatas = {
    allData: null,
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const iniAllFilters = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? user?.name : user?.gym_name || "",
          value: user?.gym_id || user?.uid || user?.user_id || "",
        }
      : prevFilters.selectedGym
      ? prevFilters.selectedGym
      : "",
    selectedTrainer: prevFilters.selectedTrainer
      ? prevFilters.selectedTrainer
      : "",
    selectedStartDate: "",
    selectedEndDate: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniTbFilters = {
    page: isPage + 1,
    limit: 10,
    trainer_id: "",
    gym_id: !isAdmin ? user?.gym_id || user?.uid || user?.user_id : "",
  };
  const [tbFilters, setTbFilters] = useState(iniTbFilters);
  const iniClickVals = {
    imageModal: false,
    shiftDetailModal: false,
    viewImage: "",
    userName: "",
    userNo: "",
    trainerId: "",
    gymId: "",
    trainerInfo: "",
    rowData: "",
    cardName: "",
  };
  const [clickValues, setClickValues] = useState(iniClickVals);
  const [shiftFormattedQP, setShiftFormattedQP] = useState("");

  const onClickValues = (e, row, name) => {
    e.preventDefault();

    if (name === "view-img") {
      setClickValues({
        imageModal: true,
        viewImage: row?.trainer_profile || BodyBuilder,
        userName: row?.trainer_name || "",
        userNo: row?.trainer_mobile || "",
        cardName: name,
      });
    } else if (
      name === "shift-details" ||
      name === "active" ||
      name === "expiring" ||
      name === "expired" ||
      name === "pt-this-month"
    ) {
      setClickValues((prevs) => ({
        ...prevs,
        shiftDetailModal: true,
        trainerId: row?.trainer_id || "",
        gymId: row?.gym_id || "",
        cardName: name,
      }));
    } else if (name === "trainer-details") {
      setClickValues((prevs) => ({
        ...prevs,
        shiftDetailModal: true,
        trainerInfo: {
          trainer_name: row?.trainer_name || "",
          trainer_id: row?.trainer_id || "",
        },
        cardName: name,
      }));
    }
  };

  const onCloseModal = () => {
    setClickValues(iniClickVals);
  };

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
  };

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin
        ? {
            label: isGym ? user?.name : user?.gym_name || "",
            value: user?.gym_id || user?.uid || user?.user_id || "",
          }
        : prevFilters.selectedGym
        ? prevFilters.selectedGym
        : "",
      selectedTrainer: prevFilters.selectedTrainer
        ? prevFilters.selectedTrainer
        : "",
    }));
  }, [prevFilters.selectedGym, prevFilters.selectedTrainer, user?.gym_id]);

  useEffect(() => {
    setTbFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      gym_id: allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
    }));
  }, [isPage, allFilters.selectedGym, allFilters.selectedTrainer]);

  useEffect(() => {
    if (tbFilters) {
      dispatch(
        fetchApiData({
          method: "GET",
          endpoint: trainerInfo,
          payload: {
            filters: tbFilters,
          },
          token: user?.token,
        })
      );
    }
  }, [tbFilters]);

  useEffect(() => {
    if (data?.status && data?.data?.length > 0) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: data.data || [],
        pagination: data?.pagination || [],
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [data]);

  useEffect(() => {
    const trainerQP = `&trainer_id=${clickValues.trainerId || ""}`;
    const gymQP = `&gym_id=${clickValues.gymId || ""}`;
    const allQP = `${trainerQP}${gymQP}`;
    setShiftFormattedQP(allQP);
  }, [clickValues.trainerId, clickValues.gymId]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "trainer_name",
      text: "Trainer/PT",
      formatter: (cell, row, rowIndex) => (
        <div
          className="emeberDetailsRowContainer"
          style={{ textAlign: "center", justifyContent: "center", gap: "1rem" }}
        >
          <img
            src={row?.trainer_profile || BodyBuilder}
            alt={row?.trainer_name || "N/A"}
            className="image"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "4px",
              border: "1px solid #000",
              padding: "10px",
              cursor: "pointer",
            }}
            onClick={(e) => {
              onClickValues(e, row, "view-img");
            }}
          />
          <span
            className="tb-data hoverBlue minWidth150"
            style={{
              textAlign: "start",
              textDecoration: "underline",
            }}
            onClick={(e) => onClickValues(e, row, "trainer-details")}
          >
            {row?.trainer_name || "NA"}
            <br />
            {row?.trainer_mobile || "NA"}
            {row?.trainer_category === "Personal Trainer" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-patch-check-fill"
                viewBox="0 0 16 16"
                style={{
                  marginLeft: "5px",
                  color: "#379C00",
                }}
              >
                <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708" />
              </svg>
            ) : null}
          </span>
        </div>
      ),
    },
    // {
    //   dataField: "trainer_category",
    //   text: "Trainer Category",
    //   formatter: (cell, row) => {
    //     return <span className="tb-data">{row?.trainer_category || "NA"}</span>;
    //   },
    // },
    {
      dataField: "joining_date",
      text: "Trainer Joining Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth90">
            {row?.joining_date ? convertStraight(row.joining_date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "salary",
      text: "Trainer Salary",
      formatter: (cell, row) => {
        return <span className="tb-data">₹{row?.salary || 0}</span>;
      },
    },
    {
      dataField: "shift_timing",
      text: "Trainer Shift",
      formatter: (cell, row) => {
        const shiftTimings = row?.shift_timing?.map((shift) => {
          const startTime = shift?.start_time
            ? moment(shift.start_time, "HH:mm")
                .tz("Asia/Kolkata")
                .format("h:mmA")
            : "";
          const endTime = shift?.end_time
            ? moment(shift.end_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
            : "";
          return `${startTime}-${endTime}`;
        });

        const shiftTiming = shiftTimings
          ? shiftTimings?.join(", ")
          : "No Shift Found";

        return <span className="tb-data minWidth150">{shiftTiming || ""}</span>;
      },
    },
    {
      dataField: "total_active_pt",
      text: "Active PT",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100 withPadding borderRdius8  bold"
            style={{
              background: "#E2EFD5",
              color: "#379C00",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={(e) => onClickValues(e, row, "active")}
          >
            {row?.total_active_pt || 0} / {row?.total_pt || 0}
          </span>
        );
      },
    },
    {
      dataField: "pt_this_month_added",
      text: "PT Added This Month",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100 withPadding borderRdius8  bold"
            style={{
              background: "#E2EFD5",
              color: "#379C00",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={(e) => onClickValues(e, row, "pt-this-month")}
          >
            {row?.pt_this_month_added || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_expiring_pt",
      text: "Expiring PT",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100 withPadding borderRdius8  bold"
            style={{
              background: "#F6EFEF",
              color: "#F13434",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={(e) => onClickValues(e, row, "expiring")}
          >
            {row?.total_expiring_pt || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_expired_pt",
      text: "Expired PT",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth100 withPadding borderRdius8  bold"
            style={{
              background: "#F6EFEF",
              color: "#F13434",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={(e) => onClickValues(e, row, "expired")}
          >
            {row?.total_expired_pt || 0}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer" style={{ gap: "0" }}>
          {/* <button
            type="button"
            className="actionBtn icon view-icon"
            onClick={(e) => onClickValues(e, row, "active")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-view-list"
              viewBox="0 0 16 16"
            >
              <path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2m0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14" />
            </svg>
          </button> */}
          <button
            type="button"
            className="actionBtn icon clock-icon"
            onClick={(e) => onClickValues(e, row, "shift-details")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-clock-history"
              viewBox="0 0 16 16"
            >
              <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z" />
              <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z" />
              <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5" />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      {/* IMAGE MODAL */}
      <Modal
        isOpen={clickValues.imageModal}
        onRequestClose={() => onCloseModal("img-modal")}
        contentLabel="View Image Modal"
        ariaHideApp={false}
      >
        <div
          className="createNewCTOModalContainer discussionModalBriefContainer"
          style={{
            width: "auto",
            height: "auto",
          }}
        >
          <ModalHeadAndClose
            title={`${clickValues.userName} / ${clickValues.userNo}`}
            onClose={() => onCloseModal("img-modal")}
          />
          <div className="discussionModalMessage mt30">
            <img
              src={clickValues.viewImage}
              alt="profile"
              style={{
                width: "400px",
                height: "400px",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      </Modal>
      {/* ---------- IMAGE MODAL ---------- */}

      {/* SHIFT AVAILABILITY MODAL */}
      <Modal
        isOpen={clickValues.shiftDetailModal}
        onRequestClose={() => onCloseModal("shift-details")}
        contentLabel="Trainer Shift Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <ModalHeadAndClose
            title={`${clickValues.cardName?.replace(/-/g, " ")}`}
            onClose={() => onCloseModal("shift-details")}
          />

          {clickValues.cardName === "active" ||
          clickValues.cardName === "expiring" ||
          clickValues.cardName === "expired" ||
          clickValues.cardName === "pt-this-month" ? (
            <PtDetails allInfo={clickValues} filters={tbFilters} />
          ) : clickValues.cardName === "shift-details" ? (
            <OccupencyDetails queryParametersForAll={shiftFormattedQP} />
          ) : clickValues.cardName === "trainer-details" ? (
            <TrainerDetailsPage
              trainerDetailsInfo={clickValues.trainerInfo}
              newQueryParametersForAll={
                tbFilters.gym_id ? `&gym_id=${tbFilters.gym_id}` : ""
              }
              decryptedText={user}
            />
          ) : null}
        </div>
      </Modal>
      {/* ---------- SHIFT AVAILABILITY MODAL ---------- */}

      <FiltersTrainerDetails
        name={"trainer-details-info"}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickReset={onClickReset}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={tbDatas.allData}
            tableColumns={tbColumns}
            tablePagination={tbDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        )}
      </div>
    </>
  );
};

export default TrainerInfo;
